// extracted by mini-css-extract-plugin
export default {"container":"nF-z","modal":"oF-z","dimensions":"pF-z","brandName":"qF-z","productName":"rF-z","labelValue":"sF-z","recipientEmail":"tF-z","recommendedFit":"uF-z","hiddenField":"vF-z"};